import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import { useTranslations } from '../../locales/useTranslations';


const WebEntwicklungFAQ = () => {
    const { t } = useTranslations();
    return (
        <section className="faq-area ptb-100 bg-color-f4f5fe" >
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-7 col-md-12">
                        <div className="faq-accordion">
                            <h2><span>{t('webDevelopment_faq_title')}</span></h2>

                            <div className="native-accordion">
                                {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                                    <details key={i} open={i === 1}>
                                        <summary>{t(`webDevelopment_faq_q${i}`)}</summary>
                                        <div className="accordion-content">
                                            <p>{t(`webDevelopment_faq_a${i}`)}</p>
                                        </div>
                                    </details>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-5 col-md-12">
                        <div className="faq-image">
                            <Player
                                autoplay
                                loop
                                src="/images/lottie/faq.json"
                                style={{ height: '300px' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default WebEntwicklungFAQ;